"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeCacheResult = exports.removeGps = exports.setGpsCookie = exports.getGpsCookie = exports.gpsCookieRefresh = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
const localConsole_1 = __importDefault(require("../utils/localConsole"));
// area 값이 비었더라도 실행할수 있고, area 값을 설정할것이면 region 과 함께 호출하는 함수
// 결과값은 좌표값이 반환됨
function gpsStorageCtrl(region) {
    if (region) {
        gpsCookieRefresh(region);
    }
    const dcgps = js_cookie_1.default.get("dcgps") ? js_cookie_1.default.get("dcgps") : "";
    const parsedCookie = dcgps ? JSON.parse(dcgps) : "";
    const dcgpsLat = parsedCookie ? parsedCookie.lat : "";
    const dcgpsLng = parsedCookie ? parsedCookie.lng : "";
    return { dcgpsLat, dcgpsLng };
}
exports.default = gpsStorageCtrl;
function gpsCookieRefresh(region) {
    const dcgps = js_cookie_1.default.get("dcgps") ? js_cookie_1.default.get("dcgps") : "";
    const parsedCookie = dcgps ? JSON.parse(dcgps) : "";
    try {
        if (region) {
            js_cookie_1.default.remove("dcgps");
            js_cookie_1.default.set("dcgps", JSON.stringify({
                area: region,
                lat: parsedCookie.lat,
                lng: parsedCookie.lng,
            }), {
                expires: 7,
                domain: window.location.href.includes("localhost")
                    ? ""
                    : ".diningcode.com",
            });
        }
    }
    catch (err) {
        localConsole_1.default?.log(err);
    }
}
exports.gpsCookieRefresh = gpsCookieRefresh;
function getGpsCookie() {
    const dcgps = js_cookie_1.default.get("dcgps") ? js_cookie_1.default.get("dcgps") : "";
    const { lat, lng, area } = dcgps ? JSON.parse(dcgps) : "";
    return { lat, lng, area };
}
exports.getGpsCookie = getGpsCookie;
function setGpsCookie(pos) {
    // 쿠키에 저장
    js_cookie_1.default.set("dcgps", JSON.stringify({
        lat: pos.coords.latitude,
        lng: pos.coords.longitude,
    }), {
        expires: 7,
        domain: window.location.href.includes("localhost")
            ? ""
            : ".diningcode.com",
    });
}
exports.setGpsCookie = setGpsCookie;
// 추천페이지 세션스토리지 캐시 제거
// 결과값에도 내위치가 담겨있으므로 제거
function removeGps() {
    // 갱신을 위한 제거
    js_cookie_1.default.remove("dcgps");
}
exports.removeGps = removeGps;
function removeCacheResult() {
    sessionStorage.removeItem("result_data_");
    sessionStorage.removeItem("req_params_");
}
exports.removeCacheResult = removeCacheResult;
